@if (type.includes('icon')) {
  <i [ngClass]="['owi', 'owi-'+((weather$ | async)?.current?.weather[0].icon?? 'none')]"></i>
}

@if (type.includes('temp')) {
  {{ temperature$ | async }}
}
